import { render, staticRenderFns } from "./OidcCallback.vue?vue&type=template&id=49a5130a"
import script from "./OidcCallback.vue?vue&type=script&lang=ts"
export * from "./OidcCallback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports